import React, { useEffect, useState } from "react";
import { successAlert } from "../../../style/scss/utils/Alerts";
import {
  autoDebitEmiPayment,
  emandateRegistration,
  saveAutoDebitEmi,
  updateBankDetails,
} from "../../../apis/customers";
import { months } from "moment";

declare global {
  interface Window {
    Razorpay: any;
  }
}

const ENach = ({ customerData }) => {
  const user = customerData;
  const userData = JSON.parse(sessionStorage.getItem("info"));

  const [formData, setFormData] = useState({
    full_name: "",
    customerEmail: "",
    customerPhone: "",
    loan_id: "",
    emi_amount: "",
    months: "",
  });
  useEffect(() => {
    if (user) {
      setFormData((prev) => ({
        full_name: user.customer.full_name || "",
        customerEmail: user.customer.email || "",
        customerPhone: user.customer.phoneNumber1 || "",
        loan_id: user.id || "",
        emi_amount: user.emi_details[0].emis[0].amount || "",
        months: user.numberOfEmis || "",
      }));
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // const isFormBlank =
  //     !formData.bankName && !formData.bankAccountNo && !formData.ifscCode;

  // const shouldShowSaveButton =
  //     userData?.type === "financer" || isFormBlank;

  const handleSubmit = async () => {
    try {
      const data = await emandateRegistration(formData);
      const options = {
        key: "rzp_test_5Aa5XzzY9f7Sna",
        amount: data.order.amount,
        currency: data.order.currency,
        order_id: data.order.id,
        customer_id: "cust_QOYArBA99KxrTP",
        name: "Loan EMI Auto-Debit",
        description: "Setup Auto-Debit Mandate",
        handler: async function (response) {
          //   await saveMandate({
          //     loan_id: formData.loan_id,
          //     customer_id: response.razorpay_customer_id,
          //     // mandate_id: response.razorpay_mandate_id,
          // });
          alert("Mandate Registered Successfully!");
        },
        prefill: {
          name: formData.full_name,
          email: formData.customerEmail,
          contact: formData.customerPhone,
        },
        method: { emandate: true },
        token: {
          max_amount: data.order.amount, // same as EMI amount
          expire_at: Math.floor(Date.now() / 1000) + 365 * 24 * 60 * 60, // expiry 1 year from now
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to register mandate.");
    }
  };

  const saveMandate = async (p0?: { loan_id: string }) => {
    await saveAutoDebitEmi({
      // loan_id: loanId,
      // customer_id: customerId,
      // mandate_id: mandateId,
    });
    alert("Mandate Info Saved");
  };

  const autoDebitEmi = async () => {
    autoDebitEmiPayment({
      //    loan_id: loanId
    });
    alert("Auto Debit Triggered");
  };

  // const handleMandatePayment = async () => {
  //     try {
  //       const res = await axios.post('http://localhost:5000/create-mandate-order', {
  //         customer_name: 'John Doe',
  //         customer_email: 'john@example.com',
  //         customer_contact: '9876543210',
  //         amount: 1000, // Amount in INR
  //       });

  //       const { order } = res.data;

  //       const options = {
  //         key: 'YOUR_KEY_ID', // 🔥 Replace with your public Razorpay key
  //         amount: order.amount,
  //         currency: order.currency,
  //         order_id: order.id,
  //         name: 'Your Company Name',
  //         description: 'Setup Auto-Debit Mandate',
  //         handler: function (response) {
  //           // Save payment id or show success message
  //         },
  //         prefill: {
  //           name: 'John Doe',
  //           email: 'john@example.com',
  //           contact: '9876543210',
  //         },
  //         method: {
  //           emandate: true,
  //         },
  //         theme: {
  //           color: '#3399cc',
  //         },
  //       };

  //       const rzp = new window.Razorpay(options);
  //       rzp.open();
  //     } catch (error) {
  //       console.error('Error during mandate setup:', error);
  //     }
  //   };

  return (
    <div className="modal fade" id="enach">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h3>E-Mandate Details</h3>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="full_name"
                  value={formData.full_name}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="customerEmail"
                  value={formData.customerEmail}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Phone</label>
                <input
                  type="text"
                  className="form-control"
                  name="customerPhone"
                  value={formData.customerPhone}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Loan ID</label>
                <input
                  type="text"
                  className="form-control"
                  name="loan_id"
                  value={formData.loan_id}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">EMI Amount</label>
                <input
                  type="number"
                  className="form-control"
                  name="emi_amount"
                  value={formData.emi_amount}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Months</label>
                <input
                  type="number"
                  className="form-control"
                  name="months"
                  value={formData.months}
                  onChange={handleChange}
                />
              </div>

              <div className="col-12 text-end">
                <button className="btn btn-primary" onClick={handleSubmit}>
                  Register Mandate
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ENach;
